import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, InputLabel } from '@mui/material';
import { FileUploaderRegular } from '@uploadcare/react-uploader';

import '@uploadcare/react-uploader/core.css';

const styles = `
  .file-uploader-wrapper uc-file-uploader-regular {
    width: 100% !important;
  }

  .file-uploader-wrapper uc-file-uploader-regular uc-simple-btn {
    width: 100% !important;
  }

  .file-uploader-wrapper uc-file-uploader-regular uc-simple-btn button {
    height: 37px !important;
    margin-bottom: 1px !important;
    border: 1px solid rgba(10, 14, 19, 0.38) !important;
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .file-uploader-wrapper uc-file-uploader-regular uc-simple-btn button span {
    margin-left: 8px !important;
  }
`;

const AvatarUploadField = forwardRef(({ onChange }, ref) => {
  const uploaderRef = useRef(null);

  useImperativeHandle(ref, () => ({
    triggerUpload: () => {
      // Find the upload button and click it
      if (uploaderRef.current) {
        const button = uploaderRef.current.querySelector('button');
        if (button) {
          button.click();
        }
      }
    },
  }));

  return (
    <Box sx={{ mt: '6px', mb: 2, width: '100%' }}>
      <style>{styles}</style>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: '14px',
        }}
      >
        <InputLabel
          sx={{
            color: 'text.primary',
            fontWeight: 500,
          }}
        >
          Profile Image
        </InputLabel>
      </Box>
      <div ref={uploaderRef}>
        <FileUploaderRegular
          multipleMax={1}
          imgOnly
          useCloudImageEditor
          cropPreset="1:1"
          pubkey="0103e656e03be46f26ca"
          onFileUploadSuccess={(file) => {
            if (file && file.cdnUrl) {
              onChange('imageURL', file.cdnUrl);
            }
          }}
          classNameUploader="custom-uploader"
          className="file-uploader-wrapper"
        />
      </div>
    </Box>
  );
});

AvatarUploadField.displayName = 'AvatarUploadField';

AvatarUploadField.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  editMode: PropTypes.bool,
};

AvatarUploadField.defaultProps = {
  value: '',
  editMode: true,
};

export default AvatarUploadField;
